<template>
    <div class="vx-col w-full mb-base">
      <vs-card title="Menu" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
          <div class="flex items-center">
            <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
            <h4 style="margin-left: 10px">Menu</h4>
          </div>
          <div class="flex items-center">
            <vs-button
              color="primary"
              class="btn mb-4 md:mb-0 mr-1"
              @click="editMode = true"
            >Edit</vs-button>
            <vs-button
              color="primary"
              class="btn mb-4 md:mb-0 mr-1"
              @click="submitForm"
            >Save</vs-button>
          </div>
        </div>
        <vs-tabs>
          <vs-tab label="Menu">
            <div class="vx-row mt-6">
              <div class="vx-col lg:w-1/4 w-full">
                <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">Module Name*</div>
                  <div class="vx-col w-2/3">
                    <vs-input class="w-full" v-model="menu.module" :disabled="!editMode" />
                  </div>
                </div>
                <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">Menu Name*</div>
                  <div class="vx-col w-2/3">
                    <vs-input class="w-full" v-model="menu.menu" :disabled="!editMode" />
                  </div>
                </div>
              </div>
              <div class="vx-col lg:w-1/4 w-full">
                <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">Path*</div>
                  <div class="vx-col w-2/3">
                    <vs-input class="w-full" v-model="menu.path" :disabled="!editMode" />
                  </div>
                </div>
                <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">Icon</div>
                  <div class="vx-col w-2/3">
                    <vs-input class="w-full" v-model="menu.icon" :disabled="!editMode" />
                  </div>
                </div>
              </div>
              <div class="vx-col lg:w-1/4 w-full">
                <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">Enable</div>
                  <div class="vx-col w-2/3">
                    <vs-select
                      class="selectExample"
                      width="100%"
                      v-model="menu.enable"
                      :disabled="!editMode"
                      autocomplete
                    >
                      <vs-select-item value="1" text="Yes" />
                      <vs-select-item value="0" text="No" />
                    </vs-select>
                  </div>
                </div>
                <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">Menu Type*</div>
                  <div class="vx-col w-2/3">
                    <vs-select
                      class="selectExample"
                      width="100%"
                      v-model="menu.menu_type"
                      :disabled="!editMode"
                      autocomplete
                    >
                      <vs-select-item value="parent" text="Parent" />
                      <vs-select-item value="child" text="Child" />
                    </vs-select>
                  </div>
                </div>
              </div>
              <div class="vx-col lg:w-1/4 w-full">
                <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">Parent</div>
                  <div class="vx-col w-2/3">
                    <vs-select
                      class="selectExample"
                      width="100%"
                      v-model="menu.parent"
                      :disabled="!editMode"
                      autocomplete
                    >
                      <vs-select-item
                        v-for="(item, index) in parentOptions"
                        :key="index"
                        :value="item.id"
                        :text="item.menu"
                      />
                    </vs-select>
                  </div>
                </div>
                <div class="vx-row mb-3">
                  <div class="vx-col w-1/3">
                    Menu Sequence*
                    <br />
                    ({{ menu.sequence }} of {{menu.total}})
                  </div>
                  <div class="vx-col w-2/3">
                    <vs-input class="w-full" :disabled="!editMode" v-model="menu.sequence" />
                  </div>
                </div>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </vs-card>
    </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

// comment
export default {
  components: {
    vSelect,
    flatPickr
  },
  data() {
    return {
      editMode: false,
      isLoading: false,
      menu: {
        module: "",
        menu: "",
        path: "",
        icon: "",
        sequence: "",
        enable: "",
        menu_type: "",
        parent: ""
      },
      enables: [
        {
          name: "Yes",
          value: 1
        },
        {
          name: "No",
          value: 0
        }
      ],
      menutypes: [
        {
          name: "Parent",
          value: "Parent"
        },
        {
          name: "Child",
          value: "Child"
        }
      ],
      parentOptions: []
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    fetchData() {
      Promise.all([
        this.$http.get("rolemanagement/menu/" + this.$route.params.id),
        this.$http.get("rolemanagement/menu/parent/dropdown")
      ]).then(
        this.$http.spread((menu, parent) => {
          this.menu = menu.data;
          this.parentOptions = parent.data.data;
        })
      );
    },
    back() {
      if (this.editMode) {
        this.$vs.dialog({
          color: "warning",
          title: "Leave Page?",
          text: "Changes you made may not be saved",
          acceptText: "Leave Page",
          accept: () => this.$router.push({ name: "menu" })
        });
      } else {
        this.$router.push({ name: "menu" });
      }
    },
    submitForm() {
      this.isLoading = true;
      const data = {
        module: this.menu.module,
        menu: this.menu.menu,
        path: this.menu.path,
        icon: this.menu.icon,
        enable: this.menu.enable,
        menu_type: this.menu.menu_type,
        parent: this.menu.menu_type == "parent" ? null : this.menu.parent,
        sequence: this.menu.sequence
      };
      this.$http
        .put("rolemanagement/menu/" + this.$route.params.id + "/update", data)
        .then(res => {
          this.loading = false;
          this.$router.push({ name: "menu" });
        })
        .catch(err => console.log(err));
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>